// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// TODO: Change commented out Services/Urls when they are available
// const SOCKET_URL = "http://localhost:8783/gs-guide-websocket"
const BACK_RMA = "http://localhost:8381/api"
const BACK_LABEL = "http://34.118.24.13:6262/service/"
const BACK_FB = "localhost:8280"
const BACK_LEADS_SERVICE = "https://services.fulfillmentbridge.com/leads/api/v1"
const BACK_TRACKING_SERVICE = 'https://tracking.fulfillmentbridge.com';
const GET_LEADS_PATH = "/Leads/filter"
const GET_LEADS_COUNT_PATH = "/Leads/count"
const GET_PRODUCTS = "/Products"
const uploadedFile = "/Leads/Upload"
const updateLeadsByExcel = "/Leads/excel"
const updateLeadsBySpreadsheet = "/Leads/spreadsheet"
const GET_REFERENCE_NUMBER ="/Leads/referenceNumbers"
const GET_COUNT_ALL_LEADS_BY_STATUS_PATH = "/Leads/count-all-by-status"
const GET_SKUS_PATH = "/Leads/skus"
const GET_SKUS_BY_COMPANIES_PATH = "/Leads/getSkusByCompanies"
const GET_SKUS_BY_WEBMASTERS_PATH = "/Leads/getSkusByWebMasters"
const GET_COUNTRIES_BY_COMPANIES_PATH = "/Reports/getCountriesByCompanies"
const GET_COUNTRIES_BY_WEBMASTERS_PATH = "/Reports/getCountriesByWebMasters"
const GET_CITIES_BY_WEBMASTERS_PATH = "/Reports/getCitiesByWebMasters"
const GET_PROVINCES_BY_WEBMASTERS_PATH = "/Reports/getProvincesByWebMasters"
const GET_CITIES_BY_COMPANIES_PATH = "/Reports/getCitiesByCompanies"
const GET_PROVINCES_BY_COMPANIES_PATH = "/Reports/getProvincesByCompanies"
const GET_LEADS_BY_SEARCH_PATH = "/Search"
const EXPORT_CSV="/Leads/excel"
const WebSocket='wss://services.fulfillmentbridge.com/ws'
// Set the login and passcode
const WebSocket_login = 'FBDEVADMIN';
const WebSocket_passcode = 'hXu7hd+@oAPk?3pe';
// const SHOP_DOMAIN = "localhost:8787/prestashop"
// const BACK_TRACKING = "/api/tracking/email"

export const environment = {
  production: false,
  // SOCKET_URL,
  BACK_RMA,
  BACK_FB,
  BACK_LABEL,
  // SHOP_DOMAIN,
  // BACK_TRACKING,
  BACK_LEADS_SERVICE,
  GET_LEADS_PATH,
  GET_LEADS_COUNT_PATH,
  GET_COUNT_ALL_LEADS_BY_STATUS_PATH,
  GET_SKUS_PATH,
  GET_SKUS_BY_COMPANIES_PATH,
  GET_SKUS_BY_WEBMASTERS_PATH,
  GET_COUNTRIES_BY_COMPANIES_PATH,
  GET_COUNTRIES_BY_WEBMASTERS_PATH,
  GET_CITIES_BY_WEBMASTERS_PATH,
  GET_PROVINCES_BY_WEBMASTERS_PATH,
  GET_CITIES_BY_COMPANIES_PATH,
  GET_PROVINCES_BY_COMPANIES_PATH,
  GET_PRODUCTS,
  uploadedFile,
  EXPORT_CSV,
  updateLeadsByExcel,
  updateLeadsBySpreadsheet,
  GET_REFERENCE_NUMBER,
  WebSocket,
  WebSocket_login,
  GET_LEADS_BY_SEARCH_PATH,
  WebSocket_passcode,
  BACK_TRACKING_SERVICE
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.